type NonNullableProps<T> = {
  [K in keyof T as T[K] extends null ? never : K]: Exclude<T[K], null>;
};

export function omitNullValues<T extends object>(obj: T): NonNullableProps<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== null),
  ) as NonNullableProps<T>;
}
